var vehicle = {};

module["exports"] = vehicle;
vehicle.fuel = require("./fuel");
vehicle.manufacturer = require("./manufacturer");
vehicle.module = require("./model");
vehicle.type = require("./vehicle_type");



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ar/vehicle/index.js
// module id = 2401
// module chunks = 1610